export default class User {
    constructor (_id = 0, _name = "", _lastName = "", _email = "", _role = {}, _profileUrl = "", _upatedPass = false, _pass = "", _repeatPassword, _status = 1) {
      this.id    = _id;
      this.name  = _name;
      this.lastName  = _lastName;
      this.email = _email
      this.role  = _role
      this.profileUrl = _profileUrl
      this.changepass = _upatedPass
      this.password = _pass
      this.repeatPassword = _repeatPassword
      this.status   = _status
    }
  }
  